export const decorationDesign = {
    address: 'address',
    ':': ':',
};
